/** Outfit batch generates outfits given the batch */
import React from 'react';
import {Outfit} from '../outfit.jsx'

export class OutfitBatch extends React.Component {
    constructor(props) {
        super(props);
        this.generateOutfits = this.generateOutfits.bind(this);
        this.storeAudit = this.storeAudit.bind(this);
    }

    /**Creates an Outfit component with the corresponding items for each outfit in batch */
    generateOutfits() {
        const currentBatch = []
        for (let i = 0; i < this.props.batch.length; i++) {
            currentBatch.push(
                <div key={i} className="awsui-util-mb-l">
                    <Outfit outfitInfo={this.props.batch[i]} batchNum={i} storeAudit={this.storeAudit}/>
                </div> 
            )
        }
        if (currentBatch.length == 0) {
            return (
                <center>
                    <h2>No Outfits Loaded</h2>
                </center>
            );
        }

        return currentBatch
    }

    /**Passes batch audit data to the review page*/
    storeAudit = (batchNum, audit_status, flag, rejectionReasons, itemNum) => {
        this.props.storeAuditBatch(batchNum, audit_status, flag, rejectionReasons, itemNum);
    }

    render() {
        return (
            <div>
                <div className="awsui-util-ml-l">
                    <h1>Audit Outfits</h1>
                </div>
                <div>
                    {this.generateOutfits()}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reviewPage/outfitBatch.jsx